import { render, staticRenderFns } from "./ProdspotEdit.vue?vue&type=template&id=00d8d0a4&scoped=true"
import script from "./ProdspotEdit.vue?vue&type=script&lang=js"
export * from "./ProdspotEdit.vue?vue&type=script&lang=js"
import style0 from "./ProdspotEdit.vue?vue&type=style&index=0&id=00d8d0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8d0a4",
  null
  
)

export default component.exports